var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Share this ' + _vm.type),expression:"'Share this ' + type"}],staticClass:"share",attrs:{"name":"share"},nativeOn:{"click":function($event){return _vm.onClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }